import React from "react"
import Image from "next/image"
import type { ContentfulVideo } from "lib/cms/video"
import type { GeneralBynderAsset, InstagramPost, ReducedImage } from "types/cms"
import { SixteenNine } from "packages/ui-shared/components/SixteenNine"
import { InstagramEmbed } from "packages/acquisition/shared/components/Contentful/InstagramEmbed"

import { imageWrapper, videoContainer } from "./ImageOrVideo.css"

type Props = {
  imageOrVideo:
    | GeneralBynderAsset
    | ContentfulVideo
    | InstagramPost
    | ReducedImage
  title: string
  modulePosition: number
}

export const ImageOrVideo: React.FC<Props> = ({
  imageOrVideo,
  title,
  modulePosition,
}) => {
  if ((imageOrVideo as InstagramPost).postLink) {
    return <InstagramEmbed id={(imageOrVideo as InstagramPost).postLink} />
  }
  if ((imageOrVideo as ContentfulVideo).videoLink) {
    return (
      <div className={videoContainer}>
        <SixteenNine>
          <iframe
            width="100%"
            height="100%"
            src={(imageOrVideo as ContentfulVideo).videoLink}
            title={title}
            frameBorder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </SixteenNine>
      </div>
    )
  }
  if ((imageOrVideo as ReducedImage).__typename === "BynderAsset") {
    return (
      <div className={imageWrapper}>
        <Image
          src={
            (imageOrVideo as ReducedImage)?.src ||
            "/images/placeholders/720x654.svg"
          }
          alt={(imageOrVideo as ReducedImage)?.description || ""}
          title={(imageOrVideo as ReducedImage)?.description || ""}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1920px) 50vw"
          style={{
            objectFit: "cover",
          }}
          priority={modulePosition < 3}
        />
      </div>
    )
  }
  return (
    <div className={imageWrapper}>
      <Image
        src={
          (imageOrVideo as GeneralBynderAsset)?.bynderData?.[0].thumbnails[
            "OTF BETA"
          ] || "/images/placeholders/720x654.svg"
        }
        alt={(imageOrVideo as GeneralBynderAsset)?.description || ""}
        title={(imageOrVideo as GeneralBynderAsset)?.description || ""}
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1920px) 50vw"
        style={{
          objectFit: "cover",
        }}
        priority={modulePosition < 3}
      />
    </div>
  )
}
